module.exports = {
  title: 'Composable Text with Reanimated 👋',
  author: 'Enzo Manuel Mangano',
  date: '2025-02-18',
  slug: 'composable-text',
  tags: ['reanimated'],
};
